import { jsx as _jsx } from "react/jsx-runtime";
import { BaseIcon } from '../BaseIcon';
export const Circle = ({ height = '24px', width = '24px', fill = 'currentColor', ...rest }) => {
    return (_jsx(BaseIcon, { width: width, height: height, viewBox: '0 0 24 24', fill: 'none', ...rest, children: _jsx("circle", { cx: '12', cy: '12', r: '10', fill: fill }) }));
};
//# sourceMappingURL=Circle.js.map